import styled from 'styled-components'

import ArrowLeft from '@/assets/svgs/arrow-left.svg?react'
import { textSizeM } from '@/styles/theme/fonts.ts'

const BreadcrumbStyled = styled.button`
  ${textSizeM};
  color: ${({ theme }) => theme.colors.common.accentDark};
  display: flex;
  align-items: center;
  font-weight: 500;
  gap: 8px;
  margin-bottom: 8px;
  text-decoration: none;
`

export const Breadcrumb = ({
  id = 'breadcrumb',
  onClick,
  title,
}: {
  title: string
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  id?: string
}) => {
  return (
    <BreadcrumbStyled title={title} onClick={onClick} id={id}>
      <ArrowLeft />
      {title}
    </BreadcrumbStyled>
  )
}
